import { Power } from '@mui/icons-material';
import { TFilterType, TFilterTypeCamelCase } from '../../types/types';
import { min } from 'lodash';

type FunctionDefinitionType = {
  [key: string]: {
    fieldName: string;
    definition: string;
    flowName?: string;
  }[];
};

export const functionDefinitions: FunctionDefinitionType = {
  All: [
    {
      fieldName: 'Summarize',
      definition: 'Aggregates records to a single value',
      flowName: 'summarize',
    },
    {
      fieldName: 'Absolute',
      flowName: 'absolute',
      definition: 'Returns the absolute value of a number',
    },
    {
      fieldName: 'Addition',
      flowName: 'addition',
      definition: 'Adds two or more numbers together',
    },
    {
      fieldName: 'Ceiling',
      flowName: 'ceiling',
      definition: 'Returns the smallest integer greater than or equal to a number',
    },
    {
      fieldName: 'Floor',
      flowName: 'floor',
      definition: 'Returns the largest integer less than or equal to a number',
    },
    { fieldName: 'Division', flowName: 'division', definition: 'Divides one number by another' },
    // { fieldName: "Power", flowName: "power", definition: "Raises a number to the specified power" },
    { fieldName: 'Log', flowName: 'log', definition: 'Returns the logarithm of a number' },
    {
      fieldName: 'Min',
      flowName: 'min',
      definition: 'Returns the smallest value from a set of numbers',
    },
    {
      fieldName: 'Max',
      flowName: 'max',
      definition: 'Returns the largest value from a set of numbers',
    },
    {
      fieldName: 'Multiplication',
      flowName: 'multiplication',
      definition: 'Multiplies two or more numbers together',
    },
    {
      fieldName: 'Subtraction',
      flowName: 'subtraction',
      definition: 'Subtracts one number from another',
    },
    {
      fieldName: 'Power',
      flowName: 'power',
      definition: 'Raises a number to the specified power',
    },

    // Condition Functions
    {
      flowName: 'IfElse',
      definition: 'Executes different code blocks based on specified conditions',
      fieldName: 'If Else',
    },

    { fieldName: 'Lowercase', flowName: 'lowercase', definition: 'Converts to Lower Case' },
    { fieldName: 'Uppercase', flowName: 'uppercase', definition: 'Converts to Upper Case' },
    {
      fieldName: 'Propercase',
      flowName: 'propercase',
      definition: 'Returns first letter of every word as Upper case',
    },
    { fieldName: 'Trim', flowName: 'trim', definition: 'Trims white spaces on both the sides' },
    {
      fieldName: 'Substring Right',
      flowName: 'substringright',
      definition:
        'Returns n characters or all except n characters from right side of a text or column',
    },
    {
      fieldName: 'Substring Left',
      flowName: 'substringleft',
      definition:
        'Returns n characters or all except n characters from left side of a text or column',
    },
    {
      fieldName: 'Length',
      flowName: 'length',
      definition: 'Returns number of characters of a text or column',
    },
    {
      fieldName: 'Left Trim',
      flowName: 'ltrim',
      definition: 'Trims white spaces on the left side of a string',
    },
    {
      fieldName: 'Right Trim',
      flowName: 'rtrim',
      definition: 'Trims white spaces on the right side of a string',
    },
    {
      fieldName: 'Replace',
      flowName: 'replace',
      definition: 'Finds and replaces a substring for every occurence in a text or column',
    },
    {
      fieldName: 'Split',
      flowName: 'split',
      definition:
        'splits the text into list of items based on delimiter and returns the specific item from the list',
    },
    {
      fieldName: 'Concatenation',
      flowName: 'concat',
      definition: 'Concats the list of items into a single string',
    },
    /**
     * Date fns
     */
    {
      fieldName: 'String to Date',
      definition: 'Converts String to Date',
      flowName: 'stringToDate',
    },
    {
      fieldName: 'Date Add',
      definition: 'Adds date interval (days, months, etc) to date',
      flowName: 'addDateInterval',
    },
    {
      fieldName: 'Date Difference',
      definition: 'Returns number of date parts (weeks, years, etc) between two dates',
      flowName: 'dateInterval',
    },
    {
      fieldName: 'Date Name',
      definition: 'Returns name of the date part of a date',
      flowName: 'datePartName',
    },
    {
      fieldName: 'Date Number',
      definition: 'Returns number of the date part of a date',
      flowName: 'datePartNumber',
    },
    {
      fieldName: 'Date Truncate',
      definition: 'Truncates a date to the desired date part',
      flowName: 'truncateDate',
    },
    // { fieldName: "Today", definition: "Returns current date", flowName: 'currentDate' },
    // { fieldName: "Now", definition: "Returns current timestamp", flowName: 'currentTimestamp' },
    { fieldName: 'Min Date', definition: 'Min of a date column', flowName: 'minDate' },
    { fieldName: 'Max Date', definition: 'Max of a date column', flowName: 'maxDate' },
    {
      fieldName: 'Type Conversion',
      definition: 'converts value from one data type to another',
      flowName: 'typeCast',
    },
  ],
  Number: [
    {
      fieldName: 'Absolute',
      flowName: 'absolute',
      definition: 'Returns the absolute value of a number',
    },
    {
      fieldName: 'Addition',
      flowName: 'addition',
      definition: 'Adds two or more numbers together',
    },
    {
      fieldName: 'Ceiling',
      flowName: 'ceiling',
      definition: 'Returns the smallest integer greater than or equal to a number',
    },
    {
      fieldName: 'Floor',
      flowName: 'floor',
      definition: 'Returns the largest integer less than or equal to a number',
    },
    { fieldName: 'Division', flowName: 'division', definition: 'Divides one number by another' },
    // { fieldName: "Power", flowName: "power", definition: "Raises a number to the specified power" },
    { fieldName: 'Log', flowName: 'log', definition: 'Returns the logarithm of a number' },
    {
      fieldName: 'Min',
      flowName: 'min',
      definition: 'Returns the smallest value from a set of numbers',
    },
    {
      fieldName: 'Max',
      flowName: 'max',
      definition: 'Returns the largest value from a set of numbers',
    },
    {
      fieldName: 'Multiplication',
      flowName: 'multiplication',
      definition: 'Multiplies two or more numbers together',
    },
    {
      fieldName: 'Subtraction',
      flowName: 'subtraction',
      definition: 'Subtracts one number from another',
    },
    {
      fieldName: 'Power',
      flowName: 'power',
      definition: 'Raises a number to the specified power',
    },
  ],
  String: [
    { fieldName: 'Lowercase', flowName: 'lowercase', definition: 'Converts to Lower Case' },
    { fieldName: 'Uppercase', flowName: 'uppercase', definition: 'Converts to Upper Case' },
    {
      fieldName: 'Propercase',
      flowName: 'propercase',
      definition: 'Returns first letter of every word as Upper case',
    },
    { fieldName: 'Trim', flowName: 'trim', definition: 'Trims white spaces on both the sides' },
    {
      fieldName: 'Substring Right',
      flowName: 'substringright',
      definition:
        'Returns n characters or all except n characters from right side of a text or column',
    },
    {
      fieldName: 'Substring Left',
      flowName: 'substringleft',
      definition:
        'Returns n characters or all except n characters from left side of a text or column',
    },
    {
      fieldName: 'Length',
      flowName: 'length',
      definition: 'Returns number of characters of a text or column',
    },
    {
      fieldName: 'Left Trim',
      flowName: 'ltrim',
      definition: 'Trims white spaces on the left side of a string',
    },
    {
      fieldName: 'Right Trim',
      flowName: 'rtrim',
      definition: 'Trims white spaces on the right side of a string',
    },
    {
      fieldName: 'Replace',
      flowName: 'replace',
      definition: 'Finds and replaces a substring for every occurence in a text or column',
    },
    {
      fieldName: 'Split',
      flowName: 'split',
      definition:
        'splits the text into list of items based on delimiter and returns the specific item from the list',
    },
    {
      fieldName: 'Concatenation',
      flowName: 'concat',
      definition: 'Concats the list of items into a single string',
    },
  ],
  Date: [
    {
      fieldName: 'String to Date',
      definition: 'Converts String to Date',
      flowName: 'stringToDate',
    },
    {
      fieldName: 'Date Add',
      definition: 'Adds date interval (days, months, etc) to date',
      flowName: 'addDateInterval',
    },
    {
      fieldName: 'Date Difference',
      definition: 'Returns number of date parts (weeks, years, etc) between two dates',
      flowName: 'dateInterval',
    },
    {
      fieldName: 'Date Name',
      definition: 'Returns name of the date part of a date',
      flowName: 'datePartName',
    },
    {
      fieldName: 'Date Number',
      definition: 'Returns number of the date part of a date',
      flowName: 'datePartNumber',
    },
    {
      fieldName: 'Date Truncate',
      definition: 'Truncates a date to the desired date part',
      flowName: 'truncateDate',
    },
    // { fieldName: "Today", definition: "Returns current date", flowName: 'currentDate' },
    // { fieldName: "Now", definition: "Returns current timestamp", flowName: 'currentTimestamp' },
    { fieldName: 'Min Date', definition: 'Min of a date column', flowName: 'minDate' },
    { fieldName: 'Max Date', definition: 'Max of a date column', flowName: 'maxDate' },
  ],
  Condition: [
    {
      flowName: 'IfElse',
      definition: 'Executes different code blocks based on specified conditions',
      fieldName: 'If Else',
    },
  ],
  Aggregation: [
    {
      fieldName: 'Summarize',
      definition: 'Aggregates records to a single value',
      flowName: 'summarize',
    },
  ],
  'Datatype Conversion': [
    {
      fieldName: 'Type Conversion',
      definition: 'converts value from one data type to another',
      flowName: 'typeCast',
    },
  ],
  // Aggregation: [
  //     { fieldName: "Aggregation", definition: "Performs calculations on a set of values to return a single value" }
  // ]
};

export const minMax: {
  [key: string]: {
    [key: string]: {
      min: number;
      max: number;
    };
  };
} = {
  Number: {
    absolute: { min: 1, max: 1 },
    addition: { min: 2, max: 8 },
    ceiling: { min: 1, max: 1 },
    floor: { min: 1, max: 1 },
    division: { min: 2, max: 2 },
    power: { min: 1, max: 1 },
    log: { min: 1, max: 1 },
    min: { min: 2, max: 8 },
    max: { min: 2, max: 8 },
    multiplication: { min: 2, max: 8 },
    subtraction: { min: 2, max: 2 },
    Power: { min: 1, max: 1 },
  },
  String: {
    lowercase: { min: 1, max: 1 },
    uppercase: { min: 1, max: 1 },
    propercase: { min: 1, max: 1 },
    trim: { min: 1, max: 1 },
    substringleft: { min: 1, max: 1 },
    substringright: { min: 1, max: 1 },
    length: { min: 1, max: 1 },
    ltrim: { min: 1, max: 1 },
    rtrim: { min: 1, max: 1 },
    replace: { min: 1, max: 1 },
    split: { min: 1, max: 1 },
    concat: { min: 2, max: 6 },
  },
  Date: {
    stringToDate: { min: 1, max: 1 },
    addDateInterval: { min: 1, max: 1 },
    dateInterval: { min: 2, max: 2 },
    datePartName: { min: 1, max: 1 },
    datePartNumber: { min: 1, max: 1 },
    truncateDate: { min: 1, max: 1 },
    currentDate: { min: 0, max: 0 },
    currentTimestamp: { min: 0, max: 0 },
    minDate: { min: 1, max: 1 },
    maxDate: { min: 1, max: 1 },
  },
  Condition: {
    /** this is not correct */
    IfElse: { min: 1, max: 1 },
  },
  Aggregation: {
    summarize: {
      min: 1,
      max: 1,
    },
  },
  'Datatype Conversion': {
    typeCast: {
      min: 1,
      max: 1,
    },
  },
};

export const lengthOfSourceArray = {
  absolute: { min: 1, max: 1 },
  addition: { min: 2, max: 8 },
  ceiling: { min: 1, max: 1 },
  floor: { min: 1, max: 1 },
  division: { min: 2, max: 2 },
  power: { min: 2, max: 2 },
  log: { min: 2, max: 2 },
  min: { min: 2, max: 8 },
  max: { min: 2, max: 8 },
  multiplication: { min: 2, max: 8 },
  subtraction: { min: 2, max: 2 },
  IfElse: { min: 1, max: 1 },

  lowercase: { min: 1, max: 1 },
  uppercase: { min: 1, max: 1 },
  propercase: { min: 1, max: 1 },
  trim: { min: 1, max: 1 },
  substringleft: { min: 3, max: 3 },
  substringright: { min: 3, max: 3 },
  length: { min: 1, max: 1 },
  ltrim: { min: 1, max: 1 },
  rtrim: { min: 1, max: 1 },
  replace: { min: 3, max: 3 },
  split: { min: 4, max: 4 },
  concat: { min: 2, max: 6 },

  dateInterval: { min: 3, max: 3 },
  datePartName: { min: 2, max: 2 },
  datePartNumber: { min: 2, max: 2 },
  truncateDate: { min: 2, max: 2 },
  minDate: { min: 1, max: 1 },
  maxDate: { min: 1, max: 1 },
  stringToDate: { min: 6, max: Infinity },
  addDateInterval: { min: 3, max: 3 },
  currentDate: { min: 0, max: 0 },
  currentTimestamp: { min: 0, max: 0 },

  summarize: {
    min: 1,
    max: 1,
  },

  typeCast: {
    min: 3,
    max: 4,
  },
};
export type SourceFunction = keyof typeof lengthOfSourceArray;
export const allowAggregationFlowTypes = ['Number'];
export const flowOverrideTypes: {
  key: TFlowOverrideType;
  value: string;
}[] = [
  {
    key: 'honorAll',
    value: 'Honor All',
  },
  {
    key: 'honorSome',
    value: 'Honor Some',
  },
  {
    key: 'ignoreAll',
    value: 'Ignore All',
  },
  {
    key: 'ignoreSome',
    value: 'Ignore Some',
  },
];
export type TFlowOverrideType = 'ignoreSome' | 'ignoreAll' | 'honorSome' | 'honorAll';
export const aggregations = [
  { displayName: 'sum', value: 'sum', mathOperation: true },
  { displayName: 'avg', value: 'avg', mathOperation: true },
  { displayName: 'min', value: 'min', mathOperation: true },
  { displayName: 'max', value: 'max', mathOperation: true },
  { displayName: 'count', value: 'count' },
  { displayName: 'count Non Null', value: 'countnn' },
  { displayName: 'count Null', value: 'countn' },
  { displayName: 'count Unique', value: 'countu' },
];

export const visuallyAggregatedFunctionNames = [
  'minDate',
  'maxDate',
  'absolute',
  'log',
  'summarize',
  'ceiling',
  'floor',
  'addition',
  'division',
  'multiplication',
  'subtraction',
  'power',
];

export const rowLevelCalculationFunctions = [
  'stringToDate',
  'addDateInterval',
  'dateInterval',
  'datePartName',
  'datePartNumber',
  'truncateDate',
  'currentDate',
  'currentTimestamp',
  'IfElse',
  'lowercase',
  'uppercase',
  'propercase',
  'trim',
  'substringleft',
  'substringright',
  'length',
  'ltrim',
  'rtrim',
  'replace',
  'split',
  'min',
  'max',
  'absolute',
  'log',
  'ceiling',
  'floor',
  'addition',
  'division',
  'multiplication',
  'subtraction',
  'power',
  'concat',
  'typeCast',
];
